<template>
  <div class="my-4">
    <div v-for="item in items" :key="item.id" class="rounded p-3 bg-gray my-3">
      <div class="row">
        <div class="col-12 col-md">
          <div class="data-name">Tipo de Documento:</div>
          <div>{{ item.documentType.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="data-name">Archivo:</div>
          <div>{{ item.document.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="d-flex justify-content-end mt-1">
            <action-button
              v-if="!isReadOnly"
              i="fas fa-times-circle"
              variant="outline-danger mr-2"
              @click="remove(item)"
            />
            <action-button
              i="fas fa-file-download"
              variant="success"
              @click="download(item.document)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAdd" class="rounded p-3 bg-gray my-3">
      <validation-observer
        ref="determinationPurchaseServiceDocumentsForm"
        v-slot="{ failed }"
        novalidate
      >
        <div class="row">
          <div class="col-12 col-md">
            <validation-provider
              v-slot="{ errors }"
              :rules="validate ? 'required' : ''"
            >
              <custom-drop-down
                v-model="model.documentType"
                :class="{
                  'was-Invalidated-select': !!errors[0],
                }"
                custom-error-msg="El campo es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Documento:"
                :options="documentTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-5">
            <div class="data-name mb-2">
              Archivo:
            </div>
            <validation-provider
              v-slot="{ errors }"
              :rules="validate ? 'required' : ''"
            >
              <custom-file-input
                ref="fileUpload"
                v-model="model.file"
                accept=".pdf"
                custom-error-msg="El documento es requerido"
                display-style="normal"
                :error="errors[0]"
                :on-download="() => {}"
              />
            </validation-provider>
          </div>
          <div
            class="col-12 col-md-3 d-flex justify-content-center align-items-center"
            :class="{
              'pt-4': !failed,
            }"
          >
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-2"
              @click="cancel"
            />
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else-if="!isReadOnly" class="d-flex justify-content-end">
      <action-button
        i="fas fa-file-plus"
        text="Añadir"
        variant="success"
        @click="showAdd = true"
      />
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';

import generalApi from '@/modules/app/api';

import {
  saveDeterminationDocument,
  deleteDeterminationDocument,
  getDeterminationDocumentTypes,
} from '@/modules/purchaseService/api.js';

import { serialize as objectToFormData } from 'object-to-formdata';

export default {
  name: 'DeterminationPurchaseServiceDocuments',
  components: {
    ValidationProvider,
    CustomDropDown,
    CustomFileInput,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isSubmitting: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {},
      localSave: false,
      showAdd: false,
      documentTypes: [],
    };
  },
  computed: {
    canAdd() {
      return !this.isReadOnly && (this.showAdd || !this.items.length);
    },
    validate() {
      return this.isSubmitting || this.localSave;
    },
  },
  async mounted() {
    await this.getTypes();
  },
  methods: {
    clear() {
      this.localSave = false;
      this.model = {};
      this.$refs.determinationPurchaseServiceDocumentsForm.reset();
      this.$refs.fileUpload.removeFile();
      this.cancel();
    },
    cancel() {
      this.showAdd = false;
    },
    async getTypes() {
      const { data } = await getDeterminationDocumentTypes(this.id);
      this.documentTypes = data;
    },
    async save() {
      this.localSave = true;
      await this.$nextTick();

      const isValid = await this.$refs.determinationPurchaseServiceDocumentsForm.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Debe indicar el tipo y seleccionar un archivo válido para continuar.',
          'error'
        );
        return;
      }

      try {
        const payload = objectToFormData(this.model, {
          indices: true,
          nullsAsUndefineds: true,
        });
        const { data } = await saveDeterminationDocument(this.id, payload);
        this.items.push(data);
        this.clear();
        this.ShowToast('', 'Documento guardado exitosamente.', 'success');
      } catch {
        this.ShowToast(
          '',
          'Ocurrió un error al intentar guardar la información.',
          'error'
        );
      }
    },
    async remove({ id: documentId }) {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar este documento adjunto?',
        'Si',
        'No'
      );

      if (!confirmed) return;
      try {
        await deleteDeterminationDocument(this.id, documentId);
        this.ShowToast(
          '',
          'Documento adjunto eliminado exitosamente.',
          'success'
        );
        const index = this.items.findIndex((x) => x.id === documentId);
        this.items.splice(index, 1);
      } catch (error) {
        this.ShowToast('', error?.response?.data?.message, 'error');
      }
    },
    async download({ id }) {
      await generalApi.downloadDocumentByAttachmentId(id);
    },
  },
};
</script>
<style scoped>
div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}

::v-deep .was-Invalidated.file-input-container {
  border: 1px solid #ff0018 !important;
}
</style>
